import { name, version } from '../package.json';

export default {
    href: {
        type: String,
        docs: {
            validation: '—',
            description: 'When provided, makes the button `a`-based and sets the `href` path.',
        },
    },
    flatButtonIconSize: {
        type: String,
        default: 'default',
        validator(value) {
            return ['default', 'small', 'medium'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'Button variation must be `flat`. One of: `default`, `small`, `medium`.',
            description: 'Sets the size of icons within a flat button.',
        },
    },
    icon: {
        type: String,
        docs: {
            validation: 'Must be a valid icon name.',
            description: 'Sets the left icon.',
        },
    },
    iconRight: {
        type: String,
        docs: {
            validation: 'Must be a valid icon name.',
            description: 'Sets the right icon.',
        },
    },
    loaderAriaValuetext: {
        type: String,
        default: 'Loading...',
        docs: {
            validation: '—',
            description: 'Sets the loader `aria-valuetext` attribute.',
        },
    },
    loading: {
        type: Boolean,
        default: false,
        docs: {
            validation: 'Button variation must be `primary`.',
            description: 'If `true`, hides the button content and displays a loader in its place.',
        },
    },
    onDark: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, changes component to on-dark styling.',
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `small`, `medium`, `large`, `touch`.',
            description: 'Sets the size of the button.',
        },
    },
    text: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'Sets the button text.',
        },
    },
    variation: {
        type: String,
        default: 'secondary',
        validator(value) {
            return ['primary', 'secondary', 'flat', 'icon-only'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `primary`, `secondary`, `flat`, `icon-only`.',
            description: 'Sets the button variation.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
